<template>
  <div class="Dataset-Item">
<TopBar color="#666" activeColor="#000" :img="logo" bg="#fff" signUp="#0D53FF" :imgsrc="logo" :islogo2="true"/>
<div class="item-body" v-if="data">
<div class="body-top">
    {{data.name}}
</div>
<div class="body-content">
    <div class="conten-img" v-if="data" >
     
        <video :src="imgSrc(data)" controls type="video/x-msvideo" v-if="data.data_type==='Video'"></video>


        <audio :src="imgSrc(data)" controls v-else-if="data.data_type==='Audio'"></audio>
          <img :src="imgSrc(data)" alt="" v-else>
    </div>
    
    <div class="conten-text">
        <div class="title">
            数据信息
        </div>
        <div class="textList">
            <span class="type">上传人</span>
            <p class="message">内江数循</p>
           
        </div>
           <div class="textList">
            <span class="type">标签分类</span>
            <ul>
                <li v-for="(it,index) in data.tags" :key="index">{{it}}</li>
                
            </ul>
        </div>
       <!-- <div class="textList">
            <span class="type">数据集简介</span>
            <p class="message">{{data.profile}}</p>
        </div> -->
        <div class="textList">
            <span class="type">上传时间</span>
            <p class="message">{{formatDate(data.create_time)}}</p>
        </div>
         <!-- <div class="textList">
            <span class="type">数据集大小</span>
            <p class="message">{{bytesToSize(data.size)}}</p>
        </div> -->
         <div class="textList">
            <span class="type">浏览量</span>
            <p class="message">{{data.view_num}}</p>
        </div>
         <div class="textList">
            <span class="type">下载量</span>
            <p class="message">{{data.download_num}}</p>
        </div>
        <div class="Datasetid">
            <div class="idimg">
                
            </div>
            <p>本数据集已在区块链上存证, 存证ID:{{data.file_hash}}</p>
        </div>
        <div class="button-list">
            <p @click="handleshow">商务合作</p>
          <p class="download" @click="downloadbtn" v-if="!Type">下载测试数据集</p>
        </div>
    </div>
</div>
<div class="body-bottom">
    <div class="smallBar">
        <ul>
            <li :class="[i===index?'active':'']" v-for="(it,index) in smallBarlist" :key="index" @click="handleclick(index)">{{it}}</li>
            </ul>
    </div>
    <div class="bottom-content">
        <!-- <div class="json_text" v-if="data.data_type==='JSON'">
              <div class="boxjianjie">{{_profile}}</div>
            <div class="jsonData" v-if="_JsonData">
            数据示例:<pre>{{_JsonData}}</pre>
        </div>
        </div>
            <div class="json_text" v-else-if="data.data_type==='CSV||EXCEL'" >
              <div class="boxjianjie">{{_CSVprofile}}</div>
            <div class="jsonData"  v-if="_CSVData">
            数据字段:<pre>{{_CSVData}}</pre>
        </div>
        </div> -->
        <p >{{data.description}}</p>
        <!-- <p v-if="data.data_type==='JSON'">{{data.description}}</p> -->
        <!-- 
        <p v-else-if="i===1">{{data.data_structure}}</p>
        <p v-else-if="i===2">{{data.comments}}</p> -->
    </div>
</div>
</div>
<div class="QR" v-show="!dialogTableVisible">
<img :src="QRcode" alt="">
<p>扫描二维码咨询合作</p>
</div>
<el-dialog  :visible.sync="dialogTableVisible">
    <div class="QRbox">
        <img :src="QRcode" alt="">
        <p>扫描二维码下载数据集示例</p>
    </div>
</el-dialog>
  </div>
</template>

<script>
import img from "@/assets/bj.jpg"
import logo from "@/assets1/logo_slices/编组 2(1).png"
import QRcode from "@/assets1/Qr.png"
import TopBar from "../supermarket/TopBar"
import { Message } from 'element-ui';
import {formatDate} from '@/utils/Date';
import {bytesToSize} from "@/utils/Size"
import {getDataset} from "@/api/Dataset"
export default { 
components:{
    TopBar
},
computed: {
  _JsonData(){
    if(this.data.profile.indexOf('数据示例')===-1){
        return false
    }


    const indexnum=this.data.profile.indexOf('数据示例')
    const JsonData= this.data.profile.substring(indexnum+'数据示例:'.length).trim()
    return JsonData
  }  ,
  _profile(){
    if(this._JsonData===false){
        return this.data.profile
    }
     const indexnum=this.data.profile.indexOf('数据示例')
      const JsonData= this.data.profile.substring(0,indexnum).trim()
      return JsonData
  },
  _CSVData(){
     if(this.data.profile.indexOf('数据字段')===-1){
        return false
    }

    const indexnum=this.data.profile.indexOf('数据字段')
    const JsonData= this.data.profile.substring(indexnum+'数据字段:'.length).trim()
    return JsonData
  },
  _CSVprofile(){
    if(this._CSVData===false){
        return this.data.profile
    }
        const indexnum=this.data.profile.indexOf('数据字段')
      const JsonData= this.data.profile.substring(0,indexnum).trim()
      return JsonData
  },

  Type(){
   const noText=['Image','Video','Audio']

   
    return noText.includes(this.data.data_type)
  }
},
data(){
    return{
        dialogTableVisible:false,
        logo,
        QRcode,
        img,
        data1:
        `hdskahdlasdkjahlskdmas;dmlkasndlansldknaslkjdboiashdpahclknalsndlkasnd数据字段:[Date,Open Price,High Price,Low Price,Close Price,Volume]`
        ,
        data:this.$route.query.list,
        smallBarlist:['数据介绍']
      ,i:0
    }
},
async created(){
    // this.data=await getDataset(this.$route.params.id)

    
    
//     console.log(this.$route.params.id);
    
   if(this.data.tags){  
    return
   }else{
    this.$router.push('/Dataset')
   }

    
},
methods:{
    formatDate,
    bytesToSize,
    handleclick(index){
        this.i=index
    },
    imgSrc(it){
        return `https://${it.test_file_bucket}.oss-cn-chengdu.aliyuncs.com/${it.test_file_object}`
    },
    handleshow(){
        this.dialogTableVisible=true
    },
 async   downloadbtn(){
        try{
            const res=await getDataset(this.data.id)
             const Testurl=`https://${res.file_bucket}.oss-cn-chengdu.aliyuncs.com/${res.file_object}`
             window.open(Testurl)
            
        }catch(error){
            if(error.response.data.code===1001){
                 Message({
          message: '请先登录后下载',
          type: 'warning'
        });
        return
            }
            
            
        }
//         if(this.$store.state.isLogin()){
//  const Testurl=`https://${this.data.file_bucket}.oss-cn-chengdu.aliyuncs.com/${this.data.file_object}`
//         window.open(Testurl)
//         }else{
// Message({
//           message: '未登录无法下载',
//           type: 'warning'
//         });

//         }
       
      
        
    }
}

}
</script>

<style scoped>
.jsonData pre{
    width: 100%;
    white-space: pre-wrap;
    font-size: 14px ;
    font-family: Regular;
}
.QRbox{
text-align: center;
    
}
.QRbox img{
width: 200px;
height: 200px;
object-fit: cover;
    
}
::v-deep .el-dialog{
    width: 300px;
    top: 50%;
    transform: translateY(-75%);

}
.bottom-content{
    width: 100%;
    height: 100%;
    font-size: 14px;
    line-height: 20px;
    font-family:Regular ;
    color: #666;
}
.smallBar ul li.active::before{
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: #0D53FF;
    bottom: -8px;
}
 
.active{
color: #0D53FF;
font-family:Medium ;
}
.smallBar ul{ display: flex;
margin-bottom: 8px;}
.smallBar ul li{ margin-right: 50px;line-height: 22px;
position: relative;cursor: pointer;}
.smallBar ul li:last-child{ margin-right: 0px;}
.smallBar{
    width: 100%;
    border-bottom: 1px solid #eee;
    color: #AAAFB9;
    font-size: 16px;
    font-family: Regular;
    margin-bottom: 20px;
}
.body-bottom{
    margin-top: 30px;
    width: 1200px;
    min-height: 230px;
    border-radius: 12px;
    background-color: #fff;
    padding: 30px;
}
.button-list .download{
background-color: #fff;
color:#0D53FF ;
border: 1px solid #0D53FF;
margin-left:24px ;
}
.button-list{
    display: flex;
    margin-top: 24px;
}
.button-list p{
    width: 200px;
    height: 56px;
    border-radius: 12px;
    font-family: Regular;
    color: #fff;
    background-color:#0D53FF ;
    cursor: pointer;
    line-height: 56px;
    text-align: center;
}
.Datasetid{
    margin-top: 6px;
    display: flex;
    width: 439px;
    height: 46px;
    border-radius: 12px;
    background-color:rgba(255, 122, 23, 0.12) ;
    align-items: center;
    font-size:16px ;

    color: #5D2F0F;
    font-family: Regular;
}
.Datasetid p{
    width: 100%;
    white-space: nowrap; /* 防止换行 */
      overflow: hidden; /* 隐藏溢出的文本 */
      text-overflow: ellipsis;
      padding-right: 10px;
}
.idimg{
    background-image: url("../../assets1/数据集页面_slices/小方块.jpg");
    width: 44px;
    height: 32px;
    background-size:contain;
background-repeat: no-repeat;background-position: center;
    margin-left: 8px;
    margin-right: 12px;
}
.title{
    margin-bottom: 20px;
    font-size: 20px;
    line-height: 28px;
    font-family: Medium;
}
.conten-img img{
   width: 100%;
   height: 100%;
    border-radius: 12px;
    object-fit: cover;
    margin-right: 30px;
}
.conten-img video{
 width: 100%;
   height: 100%;
    border-radius: 12px;
    object-fit: cover;
    margin-right: 30px;
}
.conten-img audio{
 


}
.conten-img{
     border-radius: 12px;
      width: 393px;height: 393px;
          margin-right: 30px;
    display: flex;
    align-items: center;
}
.type{
    width: 90px;
}
.textList ul li{
 padding: 2px 8px ;
 background-color: rgba(13, 83, 255, 0.12);
 border-radius: 4px;
 color: #0D53FF;
 margin-right: 6px;
}
.textList ul li:last-child{
    margin-right: 0;
}
.textList ul{
    display: flex;
}
.textList{
    display: flex;
    font-size: 14px;
    line-height: 20px;
    color:#999 ;
    font-family: Regular;
    margin-bottom: 10px;

}
.textList p{
    white-space: nowrap;    /* 防止文本换行 */
  overflow: hidden;       /* 隐藏超出容器的内容 */
  text-overflow: ellipsis;/* 溢出时显示省略号 */
  width: 500px;
}


.body-content{
    width: 1200px;
    height: 450px;
    background-color: #fff;
    border-radius: 12px;
    padding: 30px;
    display: flex;
}
.body-top{
    font-size: 24px ;
    line-height: 33px;
    font-family: Medium;
    margin-bottom: 20px;
}
.item-body{
    width: 1200px;
      margin-top: 110px;
}
.QR{
    padding: 25px 14px 20px 14px ;
    background-color: #fff;
    border-radius: 12px;
    position: fixed;
    bottom: 289px ;
    right: 50px;
}
.QR p{
    font-size: 12px;
    line-height: 16px;
    font-family:Regular ;
    margin-top: 12px;
    color: #666;
}
.QR img{
width: 110px;
height: 110px;
object-fit: cover;
}
.Dataset-Item{
    /* min-width:1920px ; */
    min-height: 1080px;
    background-color: #F7F8FC;
    display: flex;
    justify-content: center;
    /* align-items: center; */
    padding-bottom: 50px;
  
}
</style>